'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-console, no-use-before-define, func-names */
/*
 * Copyright 2016 hudl
 * All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule deprecationWarning
 * 
 */

var deprecationsWarningMap = {};
var deprecationWarning = void 0;

if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
  deprecationWarning = function deprecationWarning(message) {
    var extraCondition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    // add warning name to map
    if (!deprecationsWarningMap.hasOwnProperty(message)) {
      deprecationsWarningMap[message] = false;
    }

    if (!deprecationsWarningMap[message] && !extraCondition) {
      // prevent multiple calls
      deprecationsWarningMap[message] = true;

      var currentMajor = "22.5.0-master-22XX-React15Uniform3Sup.1224".substring(1, -1); // gets it from package.json
      var nextMajor = parseInt(currentMajor, 10) + 1;

      // log message
      console.warn('INTERFACE: deprecation-notice\n' + message + ('\nThis API will be removed in ' + nextMajor + '.0.0.'));
    }
  };
} else {
  deprecationWarning = function noop() {};
}

exports.default = deprecationWarning;
module.exports = exports['default'];